<template>
  <div class="lay">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="form">
      <el-form-item label="流程KEY" prop="procKey">
        <el-input v-model="ruleForm.procKey"></el-input>
      </el-form-item>
      <el-form-item label="流程名称" prop="procName">
        <el-input v-model="ruleForm.procName"></el-input>
      </el-form-item>
      <el-form-item label="所在部门" prop="orgInfo">
        <div class="select">
    <el-tag
    closable
    disable-transitions="true"
    v-for="tag in backDatas"
    :key="tag.index"
    @close="handleCloseUser(tag)"
    >
    {{tag.name}}
    </el-tag>
    <el-button icon="el-icon-plus"  circle class="new-tag" size="small" @click="handleSelect" />
  </div>
      </el-form-item>
      <el-form-item label="流程说明" prop="remark">
        <el-input v-model="ruleForm.remark" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="完成消息">
        <el-checkbox
        v-model="ruleForm.completeToNotify"
        true-label="true" false-label="false"
        label="是否发送" />
        <el-input
          v-if="ruleForm.completeToNotify === 'true'"
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="ruleForm.completeMsgTemp">
        </el-input>
      </el-form-item>
      <el-form-item label="拒绝消息">
        <el-checkbox
        v-model="ruleForm.rejectToNotify"
        true-label="true" false-label="false"
        label="是否发送" />
        <el-input
          v-if="ruleForm.rejectToNotify === 'true'"
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="ruleForm.rejectMsgTemp">
        </el-input>
      </el-form-item>
      <el-form-item label="退回消息">
        <el-checkbox
        v-model="ruleForm.returnToNotify"
        true-label="true" false-label="false"
        label="是否发送" />
        <el-input
          v-if="ruleForm.returnToNotify === 'true'"
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="ruleForm.returnMsgTemp">
        </el-input>
      </el-form-item>
      <!-- <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">创建</el-button>
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item> -->
    </el-form>
    <OrgSelect
  isHeadimg
  :multiple="false"
  :visible.sync="dialogVisible"
  :backDatas="backDatas"
  @onChecked="handleChecked" />
  </div>
</template>

<script>
import _ from 'lodash'
import { OrgSelect } from '@/framework/components/user'
import { template } from '../constants'
export default {
  props: {
    mData: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    OrgSelect
  },
  data() {
    return {
      backDatas: [],
      dialogVisible: false,
      ruleForm: {
        procKey: '',
        procName: '',
        remark: '',
        completeMsgTemp: '',
        completeToNotify: 'false',
        rejectMsgTemp: '',
        rejectToNotify: 'false',
        returnMsgTemp: '',
        returnToNotify: 'false',
        orgId: null,
        orgInfo: null
      },
      rules: {
        procKey: [
          { required: true, message: '请输入流程KEY', trigger: 'blur' }
        ],
        procName: [
          { required: true, message: '请输入流程名称', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    mData(val, oldVal) {
      if (val !== null && oldVal === null) {
        const {
          wfSimpleProc
        } = val
        if (wfSimpleProc?.orgInfo) {
          const arr = JSON.parse(wfSimpleProc.orgInfo)
          this.backDatas = arr
        }

        if (wfSimpleProc) {
          this.ruleForm = wfSimpleProc
        }

        if (!wfSimpleProc?.completeMsgTemp) {
          this.ruleForm.completeMsgTemp = template.complete
        }

        if (!wfSimpleProc?.rejectMsgTemp) {
          this.ruleForm.rejectMsgTemp = template.reject
        }

        if (!wfSimpleProc?.returnMsgTemp) {
          this.ruleForm.returnMsgTemp = template.return
        }
      }
    },
    backDatas(users) {
      if (users.length) {
        const orgInfo = []
        users.map(item => {
          const {
            id,
            name
          } = item
          this.ruleForm.orgId = id
          orgInfo.push({
            id,
            name
          })
        })

        this.ruleForm.orgInfo = JSON.stringify(orgInfo)
      }
    },
    ruleForm: {
      handler(val) {
        this.$emit('on-mode', 'wfSimpleProc', val)
      },
      deep: true
    }
  },
  mounted() {
    // console.log(this.mData)
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.$refs[formName].model)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    handleChecked(users) {
      this.backDatas = users
    },
    handleSelect() {
      this.dialogVisible = !this.dialogVisible
    },
    handleCloseUser(tag) {
      const tags = _.filter(this.backDatas, (user) => {
        return user.id !== tag.id
      })
      this.backDatas = tags
    }
  }
}
</script>

<style lang="scss" scoped>
.lay {
  height: 100%;
  background-color: #FFF;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  padding-top: 30px;
}
.form {
  width: 460px;
}
.select{
  border-radius:5px;
  border:1px solid #DCDFE6;
  padding: 4px;
  .el-tag {
    margin-left: 10px;
  }
  .new-tag {
    margin-left: 10px;
  }
}
</style>
